const currentYear = new Date().getFullYear()
const years = []

for (let i = 0; i < 10; i++) {
  const year = currentYear - i
  years.push({ label: year.toString(), value: year })
}

export default years
